import { number, object } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { CountProductsBySchema, ProductGroupsSchema } from '@occc/validation';

export const ProductPurchaseSchema = object({
  purchaseThreshold: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  countProductsBy: CountProductsBySchema,
  eligibleProductGroups: ProductGroupsSchema,
});
